/** @jsx jsx */
import React from "react";
import { jsx, Button, useThemeUI } from "theme-ui";

import HtmlDiv from "sites-common/components/HtmlDiv";
import PropTypes from "prop-types";
import { RenderCard } from "./DonorProfile/ProfileSelector";

const RestrictionsWrapper = ({
  show,
  country,
  donorInfo,
  resetDonorInfo,
  restrictions,
  meditationPlaceFieldAvl,
}) => {
  const { theme } = useThemeUI();

  return (
    <React.Fragment>
      {show === "restrictions" && (
        <div>
          <RenderCard
            country={country}
            me={donorInfo}
            iAmSelected
            selectMe={resetDonorInfo}
            meditationPlaceFieldAvl={meditationPlaceFieldAvl}
          />
          <div
            sx={{
              ...theme.messages.variantEW,
              fontFamily: `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"`,
            }}
          >
            {restrictions.map((msg, key) => {
              const x = `y${key}x`;
              return <HtmlDiv key={x} htmlString={msg} />;
            })}
          </div>
          <Button variant="variant3" onClick={resetDonorInfo}>
            Back
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};
RestrictionsWrapper.defaultProps = {
  meditationPlaceFieldAvl: false,
};
RestrictionsWrapper.propTypes = {
  show: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  donorInfo: PropTypes.shape({}).isRequired,
  resetDonorInfo: PropTypes.func.isRequired,
  restrictions: PropTypes.shape([]).isRequired,
  meditationPlaceFieldAvl: PropTypes.bool,
};

export default RestrictionsWrapper;
